import { toNumber } from 'lodash';

const useTruncateAndFormat = (number, decimals = 0) => {
  let decimalScale = '1';
  for (let index = 0; index < decimals; index += 1) {
    decimalScale += '0';
  }
  return (
    Math.round((number + Number.EPSILON) * toNumber(decimalScale)) /
    toNumber(decimalScale)
  );
};

export default useTruncateAndFormat;
